import { WaitingModal } from "../WaitingModal";
import type { ShieldingMode } from "./shieldingConfig";

interface ShieldingWaitingModalProps {
  isOpen: boolean;
  onClose: () => void;
  txHash?: string;
  tokenSymbol?: string;
  shieldingMode?: ShieldingMode;
}

export function ShieldingWaitingModal({ isOpen, onClose, txHash, tokenSymbol = "tokens", shieldingMode = "shield" }: ShieldingWaitingModalProps) {
  const actionText = shieldingMode === "shield" ? "Shielding" : "Unshielding";

  return (
    <WaitingModal
      isOpen={isOpen}
      onClose={onClose}
      title={`${actionText} your ${tokenSymbol}...`}
      description="The transaction is being processed. You can stay or close the modal and we will notify you when the transaction is complete."
      txHash={txHash}
    />
  );
}
